import { DataTypeConfig } from "../../../../types";

export const consumerMeterMappingConfig: DataTypeConfig = {
  tabs: ["utilityService"],
  searchableColumns: ["consumer_number", "meter_number", "utility_service"],
  filterColumns: [
    { column: "utility_service", type: "dropdown", label: "Utility Service" },
  ],
  tableColumns: [
    { key: "consumer_number", header: "Consumer Number", type: "custom" },
    { key: "meter_number", header: "Meter Number", type: "custom" },
    { key: "utilityService", header: "Utility Service", type: "badge" },
  ],
  mandatoryFields: ["consumer_number", "meter_number", "utility_service"],
};

export const consumerMeterMappingTabDisplayNames: Record<string, string> = {
  utilityService: "Utility Service",
};

export const consumerMeterMappingTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "utilityService":
      return [
        { value: "electricity", label: "Electricity" },
        { value: "water", label: "Water" },
        { value: "gas", label: "Gas" },
        { value: "sewage", label: "Sewage" },
      ];
    default:
      return [];
  }
};
